import React from "react";

const IconSvg = ({
  path,
  className = "",
  viewBox = "0 0 24 24",
  fill = "none",
  stroke = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill={fill}
      viewBox={viewBox}
      stroke={stroke}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d={path}
      />
    </svg>
  );
};

export default IconSvg;
